import { render, staticRenderFns } from "./bay.vue?vue&type=template&id=0a3be9ac&scoped=true"
import script from "./bay.vue?vue&type=script&lang=js"
export * from "./bay.vue?vue&type=script&lang=js"
import style0 from "./bay.vue?vue&type=style&index=0&id=0a3be9ac&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a3be9ac",
  null
  
)

export default component.exports